import React, { Fragment } from 'react';

import { NAVIGATION } from '../utils/constants';

export default function BreedOverviewMobileNavigation() {
  return (
    <div className="BreedOverviewMobileNavigation">
      {Object.entries(NAVIGATION).map(([key, title], index, arr) => (
        <Fragment key={index}>
          <button
            type="button"
            className="font-16 fw-medium stone-700 mr1 mb1"
            onClick={() => {
              const el = document.getElementById(key);
              el?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            {title}
          </button>
          {index < arr.length - 1 && <span className="black-15 mr1"> | </span>}
        </Fragment>
      ))}
    </div>
  );
}
